export const featureList = {
  6: { feature: 'Contacts', lookupId: 6, selected: false },
  7: { feature: 'Media', lookupId: 7, selected: false },
  9: { feature: 'Business Social', lookupId: 9, selected: false },
  10: { feature: 'External Link', lookupId: 10, selected: false },
  12: { feature: 'Preferred Partners', lookupId: 12, selected: false },
};
